import React from "react";
import '../css/PopupModal.css';
import '../css/CustomPopupModal.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomPopupModal = ({
  titleStyle,
  title,
  message,
  children,
  onClose,
  isVisible,
  icon,
  iconColor = "#28a745",
  iconBorder
}) => {
  if (!isVisible) return null;

  return (
    <div className="popup-modal-overlay">
      <div className="popup-modal-content">
        {icon && (
          <div className={iconBorder} style={{ color: iconColor }}>
            <FontAwesomeIcon icon={icon} size="3x"/>
          </div>
        )}

        <h4 className={titleStyle}>{title}</h4>

        {message && <p className="popup-modal-message">{message}</p>}

        {children && <div className="popup-modal-actions">{children}</div>}
      </div>
    </div>
  );
};

export default CustomPopupModal;